import {ObjectList} from './object-list.model.interface';
import {ISimpleSelectableData} from './simple-selectable-data.model.interface';

export class PhoneStatusList extends ObjectList<IPhoneStatus, IPhoneStatus> {
  protected mapToListElement(instance: IPhoneStatus): IPhoneStatus {
    return instance;
  }

  protected mapToSelectableItem(instance: IPhoneStatus): ISimpleSelectableData {
    return {
      value: instance.id,
      label: instance.label
    };
  }

}

export interface IPhoneStatus {
  id: number;
  label: string;
  status: string;
}
